module.exports = __webpack_public_path__ + "img/union-pay.8676faf2.png";